import { render, staticRenderFns } from "./AddressPin.vue?vue&type=template&id=044037e2&"
import script from "./AddressPin.vue?vue&type=script&lang=js&"
export * from "./AddressPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports